import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
import { ThemeIcon } from '../../index';
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Faq',
    props: {
        document: {}
    },
    setup(__props) {
        const props = __props;
        const isOpen = ref(false);
        const innerEl = ref();
        const height = ref(0);
        function onOpenBegin() {
            var _a;
            height.value = ((_a = innerEl.value) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
        }
        function onOpenEnd() {
            height.value = 0;
        }
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["siteSearch-hit", { 'is--open': isOpen.value }]),
                "data-hit": "faq"
            }, [
                _createElementVNode("h4", null, [
                    _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event) => (isOpen.value = !isOpen.value))
                    }, [
                        _createElementVNode("span", {
                            innerHTML: ((_a = _ctx.document._formatted) === null || _a === void 0 ? void 0 : _a.title) || _ctx.document.title
                        }, null, 8, _hoisted_1),
                        _createVNode(_unref(ThemeIcon), { name: "chevron-right" })
                    ])
                ]),
                _createVNode(_Transition, {
                    name: "open",
                    onEnter: onOpenBegin,
                    onBeforeLeave: onOpenEnd
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            (isOpen.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "faqHit-contentWrapper",
                                    style: _normalizeStyle({ height: `${height.value}px` })
                                }, [
                                    _createElementVNode("div", {
                                        class: "faqHit-content",
                                        innerHTML: ((_a = _ctx.document._formatted) === null || _a === void 0 ? void 0 : _a.answer) || _ctx.document.answer,
                                        ref_key: "innerEl",
                                        ref: innerEl
                                    }, null, 8, _hoisted_2)
                                ], 4))
                                : _createCommentVNode("", true)
                        ];
                    }),
                    _: 1
                })
            ], 2));
        };
    }
});
